import React, {
  useState,
  useEffect,
} from "react";

import {
  Printer,
  Mail,
  X,
  CheckCircle2,
  Receipt,
  ArrowRight,
  Smartphone,
} from "lucide-react";

import { toast } from "react-toastify";

import "../css/receiptoptions.css";

import { printReceipt } from "./printReceipt";

const BACKEND_URL =
  "https://pos-backend-58o9.onrender.com";
  
const token =
  JSON.parse(
    localStorage.getItem("rcs_auth") ||
    sessionStorage.getItem("rcs_auth")
  ) || {};


const ReceiptOptions = ({
  sale,
  onClose,
}) => {

  const [
    showEmailInput,
    setShowEmailInput,
  ] = useState(false);

  const [email, setEmail] =
    useState("");

  const [
    processing,
    setProcessing,
  ] = useState(false);



const [
  emailSent,
  setEmailSent,
] = useState(false);

const [
  showSMSInput,
  setShowSMSInput,
] = useState(false);

const [
  smsNumber,
  setSmsNumber,
] = useState("");

const [
  smsSent,
  setSmsSent,
] = useState(false);


  /* =====================================================
      HOTKEY
  ===================================================== */

  useEffect(() => {

    const handleKey = (
      e
    ) => {

      const isPrintKey =
        e.key === "+" ||
        e.key === "=" ||
        e.code === "NumpadAdd";

      if (isPrintKey) {

        e.preventDefault();

        handlePrint();
      }
    };

    window.addEventListener(
      "keydown",
      handleKey
    );

    return () =>
      window.removeEventListener(
        "keydown",
        handleKey
      );

  }, []);

  /* =====================================================
      PRINT
  ===================================================== */

  const handlePrint = () => {

    const enrichedSale = {
      ...sale,

      points_earned:
        sale.points_earned || 0,

      points_redeemed:
        sale.points_redeemed || 0,

      customer:
        sale.customer ||
        sale.sender ||
        null,
    };

    printReceipt(
      enrichedSale
    );

  };

  /* =====================================================
      EMAIL
  ===================================================== */

const handleSendEmail =
  async () => {

    if (!email) {

      toast.error(
        "Enter a valid email."
      );

      return;
    }

    try {

      setProcessing(true);

      // ✅ Generate SAME PDF receipt
      const pdfBlob =
        await printReceipt(
          sale,
          "email"
        );

      // ✅ Build upload payload
      const formData =
        new FormData();

      formData.append(
        "email",
        email
      );

      formData.append(
        "receipt",
        pdfBlob,
        `Receipt-${sale.receipt_no}.pdf`
      );

      // ✅ Send to backend
      const res =
        await fetch(
          `${BACKEND_URL}/api/sales/email-receipt`,
          {
            method: "POST",
            body: formData,
          }
        );

      const data =
        await res.json();

      if (data.success) {

        toast.success(
          "Receipt emailed successfully!"
        );
setEmailSent(true);

      } else {

        toast.error(
          data.error ||
          "Failed to send receipt."
        );
      }

    } catch (err) {

      console.error(err);

      toast.error(
        "Email delivery failed."
      );

    } finally {

      setProcessing(false);
    }
  };

/* =====================================================
    SMS
===================================================== */

  
const handleSendSMS =
  async () => {

    if (!smsNumber) {

      toast.error(
        "Enter a phone number."
      );

      return;
    }

    try {

      setProcessing(true);

      // SAME PDF
      const pdfBlob =
        await printReceipt(
          sale,
          "email"
        );

      const formData =
        new FormData();

      formData.append(
        "phone",
        smsNumber
      );

      formData.append(
        "receipt_no",
        sale.receipt_no
      );

      formData.append(
        "receipt",
        pdfBlob,
        `Receipt-${sale.receipt_no}.pdf`
      );

      const res =
        await fetch(
          `${BACKEND_URL}/api/sales/sms-receipt`,
          {
            method: "POST",

            headers: {
              Authorization:
                `Bearer ${token.access_token}`,
            },

            body: formData,
          }
        );

      const data =
        await res.json();

      if (data.success) {

        toast.success(
          "SMS receipt sent!"
        );

        setSmsSent(true);

      } else {

        toast.error(
          data.error ||
          "Failed to send SMS."
        );
      }

    } catch (err) {

      console.error(err);

      toast.error(
        "SMS delivery failed."
      );

    } finally {

      setProcessing(false);
    }
  };




  return (

    <div className="modern-receipt-overlay">

      <div className="modern-receipt-modal">

        {/* =====================================================
            HEADER
        ===================================================== */}
        <div className="modern-receipt-header">

          <div className="modern-receipt-badge">

            <Receipt size={16} />

            <span>
              Receipt Center
            </span>

          </div>

          <button
            className="modern-receipt-close"
            onClick={onClose}
          >

            <X size={18} />

          </button>

        </div>

        {/* =====================================================
            CONTENT
        ===================================================== */}
        <div className="modern-receipt-content">

          <div className="modern-receipt-success">

            <div className="modern-receipt-success-icon">

              <CheckCircle2
                size={54}
              />

            </div>

            <h2>
              Transaction Completed
            </h2>

            <p>
              Receipt #
              {sale.receipt_no}
            </p>

            <h1>
              $
              {parseFloat(
                sale.total
              ).toFixed(2)}
            </h1>

          </div>

{/* =====================================================
    ACTIONS
===================================================== */}

{!showEmailInput &&
!showSMSInput && (

  <div className="modern-receipt-actions">

    {/* PRINT */}
    <button
      className="modern-receipt-action print"
      onClick={handlePrint}
    >

      <div className="modern-receipt-action-left">

        <Printer size={20} />

        <div>

          <strong>
            Print Receipt
          </strong>

          <span>
            Press +
          </span>

        </div>

      </div>

      <ArrowRight size={18} />

    </button>


    {/* SMS */}
<button
  className={`modern-receipt-action sms ${
    smsSent
      ? "disabled-action sent-action"
      : ""
  }`}

  disabled={smsSent}

  onClick={() => {

    if (smsSent) return;

    setShowEmailInput(false);

    setShowSMSInput(true);

  }}
>

  <div className="modern-receipt-action-left">

    <Smartphone size={20} />

    <div>

      <strong>
        {smsSent
          ? "SMS Sent"
          : "Send SMS"}
      </strong>

      <span>
        {smsSent
          ? "Receipt delivered successfully"
          : "SMS receipt link"}
      </span>

    </div>

  </div>

  {!smsSent && (
    <ArrowRight size={18} />
  )}

</button>


    {/* EMAIL */}
<button
  className={`modern-receipt-action email ${
    emailSent
      ? "disabled-action sent-action"
      : ""
  }`}

  disabled={emailSent}

  onClick={() => {

    if (emailSent) return;

    setShowSMSInput(false);

    setShowEmailInput(true);

  }}
>

  <div className="modern-receipt-action-left">

    <Mail size={20} />

    <div>

      <strong>
        {emailSent
          ? "Email Sent"
          : "Send Email"}
      </strong>

      <span>
        {emailSent
          ? "Receipt delivered successfully"
          : "Email digital receipt"}
      </span>

    </div>

  </div>

  {!emailSent && (
    <ArrowRight size={18} />
  )}

</button>

  </div>

)}


{/* =====================================================
    EMAIL SECTION
===================================================== */}

{showEmailInput && (

  <div className="modern-email-section">

<input
  type="email"

  placeholder={
    emailSent
      ? "Email Receipt Sent"
      : "Enter customer email"
  }

  value={
    emailSent
      ? ""
      : email
  }

  disabled={emailSent}

  onChange={(e) =>
    setEmail(e.target.value)
  }

  className="modern-email-input"
/>

    <div className="modern-email-actions">

      <button
        className="modern-email-back"
        onClick={() =>
          setShowEmailInput(false)
        }
      >
        Back
      </button>

      <button
        className="modern-email-send"

        onClick={handleSendEmail}

        disabled={
          processing ||
          emailSent
        }
      >

        {processing
          ? "Sending..."
          : emailSent
            ? "Email Sent"
            : "Send Receipt"}

      </button>

    </div>

  </div>

)}


{/* =====================================================
    SMS SECTION
===================================================== */}

{showSMSInput && (

  <div className="modern-email-section">

<input
  type="text"

  placeholder={
    smsSent
      ? "SMS Receipt Sent"
      : "Enter SMS Number"
  }

  value={
    smsSent
      ? ""
      : smsNumber
  }

  disabled={smsSent}

  onChange={(e) =>
    setSmsNumber(
      e.target.value
    )
  }

  className="modern-email-input"
/>

    <div className="modern-email-actions">

      <button
        className="modern-email-back"
        onClick={() =>
          setShowSMSInput(false)
        }
      >
        Back
      </button>

      <button
        className="modern-email-send"
        onClick={handleSendSMS}

        disabled={
          processing ||
          smsSent
        }
      >

        {processing
          ? "Sending..."
          : smsSent
            ? "SMS Sent"
            : "Send SMS"}

      </button>

    </div>

  </div>

)}
        </div>

      </div>

    </div>
  );
};

export default ReceiptOptions;